export const JANUARY = "January";
export const FEBRUARY = "February";
export const MARCH = "March";
export const APRIL = "April";
export const MAY = "May";
export const JUNE = "June";
export const JULY = "July";
export const AUGUST = "August";
export const SEPTEMBER = "September";
export const OCTOBER = "October";
export const NOVEMBER = "November";
export const DECEMBER = "December";

export const PRESENT = "Present";
export const MONTHS = "month(s)";
export const YEARS = "year(s)";
